import { render, staticRenderFns } from "./GenerateCourierReport.vue?vue&type=template&id=48210035&scoped=true&"
import script from "./GenerateCourierReport.vue?vue&type=script&lang=js&"
export * from "./GenerateCourierReport.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCourierReport.vue?vue&type=style&index=0&id=48210035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48210035",
  null
  
)

export default component.exports